import type { LightingQuality } from "@/features/assessments/components/ImageCaptureStep/captureTypes";

export function sampleVideoBrightness(
  video: HTMLVideoElement,
  canvas?: HTMLCanvasElement | null,
): number | null {
  try {
    const sampleCanvas = canvas ?? document.createElement("canvas");
    if (!canvas) {
      sampleCanvas.width = 64;
      sampleCanvas.height = 64;
    }

    const ctx = sampleCanvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return null;

    ctx.drawImage(video, 0, 0, 64, 64);
    const imageData = ctx.getImageData(16, 12, 32, 40);
    const pixels = imageData.data;

    let totalBrightness = 0;
    const pixelCount = pixels.length / 4;

    for (let i = 0; i < pixels.length; i += 4) {
      const r = pixels[i];
      const g = pixels[i + 1];
      const b = pixels[i + 2];
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      totalBrightness += luminance;
    }

    return totalBrightness / pixelCount;
  } catch {
    return null;
  }
}

export function classifyLightingQuality(avg: number): LightingQuality {
  if (avg < 0.15) {
    return "too-dark";
  }
  if (avg < 0.3) {
    return "dim";
  }
  if (avg < 0.65) {
    return "good";
  }
  if (avg < 0.8) {
    return "bright";
  }
  return "too-bright";
}
